import { render, staticRenderFns } from "./CustomerFeedbackTable.vue?vue&type=template&id=4c3062fa&"
import script from "./CustomerFeedbackTable.vue?vue&type=script&lang=ts&"
export * from "./CustomerFeedbackTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c3062fa')) {
      api.createRecord('4c3062fa', component.options)
    } else {
      api.reload('4c3062fa', component.options)
    }
    module.hot.accept("./CustomerFeedbackTable.vue?vue&type=template&id=4c3062fa&", function () {
      api.rerender('4c3062fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/CustomerFeedbackTable.vue"
export default component.exports